/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectCalculationsScenarioVentureFundsRetrieve$Params {
  scenario_pk: number;
}

export function projectCalculationsScenarioVentureFundsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsScenarioVentureFundsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsScenarioVentureFundsRetrieve.PATH, 'get');
  if (params) {
    rb.path('scenario_pk', params.scenario_pk, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectCalculationsScenarioVentureFundsRetrieve.PATH =
  '/api/project_calculations/scenario/{scenario_pk}/venture-funds/';
